import styled from 'styled-components';

export const StyledLicenseAgreementPage = styled.div`
  height: 100%;
  overflow: auto;
`;
